// components/ui/Badge.tsx — Status and label badges

import clsx from 'clsx';
import styles from './Badge.module.css';

export type BadgeVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning'
  | 'error'
  | 'neutral'
  | 'you'             // Self badge on tree node
  | 'admin'           // Tree admin/root badge on tree node
  | 'shadow'          // Unclaimed node
  | 'deceased'        // Deceased member
  | 'privacy'         // Privacy tier (generic)
  | 'claimed'         // Public / claimed profile
  | 'privacy-private'; // Locked / private profile

export type BadgeSize = 'xs' | 'sm' | 'md';

interface BadgeProps {
  label: string;
  variant?: BadgeVariant | undefined;
  size?: BadgeSize | undefined;
  dot?: boolean | undefined; // Show colored dot before label
  className?: string | undefined;
}

export function Badge({
  label,
  variant = 'neutral',
  size = 'sm',
  dot = false,
  className,
}: BadgeProps) {
  return (
    <span
      className={clsx(styles.badge, styles[variant], styles[size], className)}
    >
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {label}
    </span>
  );
}
